
webpack.register(
    'modules/broadcaster-search/broadcaster-search',
    function() {
        return import('modules/broadcaster-search/broadcaster-search');
    },
    true
);